import { render, staticRenderFns } from "./basic_info.vue?vue&type=template&id=5e249254&"
import script from "./basic_info.vue?vue&type=script&lang=js&"
export * from "./basic_info.vue?vue&type=script&lang=js&"
import style0 from "./basic_info.vue?vue&type=style&index=0&id=5e249254&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports